import {
  Autocomplete,
  Button,
  Checkbox,
  Chip,
  FormControlLabel,
  Input,
  Paper,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
// import "./CreateForm.css"; // Import the CSS file
// import TelegramIcon from "@mui/icons-material/Telegram";
// import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import CustomInput from "../../Form/CustomInput";
// import CustomImageShow from "../../Form/CustomImageShow";
import CustomButton from "../../Form/CustomButton";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
// import { axiosPrivate } from "../../../api/axios/axios";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import UpdateIcon from "@mui/icons-material/Update";
import AppConstrains from "../../../AppConstrains/AppConstrains";
import { Image } from "antd";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import { validateForm } from "../../../utils/zodValidationHelper";
import { announcementSchema } from "../../../schema/announcement.schema";
import { checkImageLoads } from "../../../utils/imageCheck";
import { hasVisibleText } from "../../../utils/hasVisibleText";
import ReactQuill from "react-quill";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const CreateAnnoucementComponent = memo(({ categories, rowData = {} }) => {
  const axiosPrivate = useAxiosPrivate();
  const categoriesOption = [
    { value: "all", label: "Select All" },
    ...categories,
  ];

  const [createAnouncementData, setCreateAnouncementData] = useState({
    url: "",
    imageURL: "",
  });
  const [selectedGroups, setSelectedGroups] = useState([]);

  const navigate = useNavigate();
  const handelChange = (event) => {
    setCreateAnouncementData({
      ...createAnouncementData,
      [event.target.name]: event.target.value,
    });
  };

  const clearForm = () => {
    setCreateAnouncementData({});
    setSelectedGroups([]);
  };

  const [isQuillFocused, setIsQuillFocused] = useState(false);

  const handleQuillChange = (value) => {
    const isValid = hasVisibleText(value);
    const finalValue = isValid ? value : null;

    setCreateAnouncementData((prev) => ({ ...prev, message: finalValue }));
  };

  const handleCreateAnnouncement = async () => {
    const formData = {}

    formData["_id"] = createAnouncementData?._id;
    formData[
      "group_id_arr"] =
      (createAnouncementData?.group_id_arr && createAnouncementData?.group_id_arr?.length > 0) ? createAnouncementData?.group_id_arr : null


    formData["url"] = createAnouncementData?.url || null
    formData["message"] = createAnouncementData?.message || null
    formData["img_url"] = createAnouncementData?.img_url || null
    formData["send_notification"]=true



    try {


      if (!createAnouncementData.message && !createAnouncementData.img_url) {
        toast.error(
          "Either image URL or text is required. Both fields cannot be empty."
        );
        return;
      }

      //Validate form Data
      const validData = validateForm(announcementSchema, formData);
      if (!validData) return;

      if (formData.img_url) {
        const isImageOk = await checkImageLoads(validData.img_url);
        if (!isImageOk) {
          toast.error("Image URL is not valid or failed to load");
          return;
        }
      }


      


      const response = await axiosPrivate.post(
        `/api/deals/senddealannouncement`,
        formData
      );

      toast.success(response.data.msg);
      clearForm();
      navigate("/annoucement");
    } catch (error) {
      toast.error(error.response.data.msg);
    }
  };

  const handleUpdateAnnouncement = async (send_notification) => {
    const formData = {}

    formData["_id"] = createAnouncementData?._id;
    formData[
      "group_id_arr"] =
      (createAnouncementData?.group_id_arr && createAnouncementData?.group_id_arr?.length > 0) ? createAnouncementData?.group_id_arr : null


    formData["url"] = createAnouncementData?.url || null
    formData["message"] = createAnouncementData?.message || null
    formData["img_url"] = createAnouncementData?.img_url || null
    formData["send_notification"] = send_notification

    try {

      console.log("Update announcement data", formData)

      if (!formData?.message && !formData?.img_url) {
        toast.error(
          "Either image URL or text is required. Both fields cannot be empty."
        );
        return;
      }


      //Validate form Data
      const validData = validateForm(announcementSchema, formData);
      if (!validData) return;

      if (formData.img_url) {
        const isImageOk = await checkImageLoads(validData.img_url);
        if (!isImageOk) {
          toast.error("Image URL is not valid or failed to load");
          return;
        }
      }


      const response = await axiosPrivate.post(
        `/api/deals/senddealannouncement`,
        formData
      );

      toast.success(response.data.msg);
      clearForm();
      navigate("/annoucement");
    } catch (error) {
      toast.error(error.response.data.msg);
    }
  };

  useEffect(() => {
    if (Object?.keys(rowData)?.length > 0) {
      console.log(rowData, "rowData");
      setCreateAnouncementData({ ...rowData });

      if (rowData?.group_id_arr) {
        // console.log("in side of rowData.categoriesdf");
        setSelectedGroups(
          rowData?.group_id_arr
            ?.map((id) => {
              const cats = categories.find((cat) => cat.value === id);
              return cats;
            })
            ?.filter((x) => x)
        );
      }


    }
  }, [rowData, categories.length]);

  console.log("Create Annoucemnet Data", createAnouncementData);

  return (
    <div>
      <Paper
        className="create-form-container"
      // sx={{ display: `${Object.keys(dealsData).length ? "block" : "none"}` }}
      >
        <Typography variant="h5" component="h5" className="form-title">
          {rowData?._id ? "Update Anouncement" : "Create Anouncement"}
        </Typography>
        <div className="form-wrapper">
          <div className="flex items-center justify-between w-full gap-4 ">
            <Autocomplete
              sx={{ width: "50%" }}
              disableCloseOnSelect
              value={selectedGroups}
              onChange={(event, newValue) => {
                // console.log(newValue, "newValue");

                const isSelectAll = newValue.some(
                  (option) => option.value === "all"
                );

                if (isSelectAll) {
                  // If "Select All" is selected, toggle all options
                  if (selectedGroups.length < categories.length) {
                    setSelectedGroups(categories);
                    setCreateAnouncementData({
                      ...createAnouncementData,
                      group_id_arr: categories.map((c) => c.value),
                    });
                  } else {
                    setSelectedGroups([]);
                    setCreateAnouncementData({
                      ...createAnouncementData,
                      group_id_arr: [],
                    });
                  }
                } else {
                  // Handle regular selections
                  setSelectedGroups(newValue);
                  setCreateAnouncementData({
                    ...createAnouncementData,
                    group_id_arr: newValue.map((option) => option.value),
                  });
                }

                // setSelectedGroups(newValue);
                // setCreateAnouncementData({
                //   ...createAnouncementData,
                //   ["categories"]: newValue.map((option) => option.value),
                // });
                // setSelectedCategoryIds(newValue.map((option) => option.value));
              }}
              className="w-full"
              multiple
              id="categories"
              options={categoriesOption}
              getOptionLabel={(option) => option.label}
              //   defaultValue={[top100Films[13].title]}

              renderTags={(value, getTagProps) =>
                value.map((option, index) => {
                  const { key, ...tagProps } = getTagProps({ index });
                  return (
                    <Chip
                      variant="outlined"
                      label={option.label}
                      key={key}
                      {...tagProps}
                    />
                  );
                })
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Groups"
                  placeholder="Add Gropus"
                  size="small"
                  required
                />
              )}
            />

            <TextField
              sx={{ width: "50%" }}
              size="small"
              name="url"
              variant="outlined"
              label="URL"
              value={createAnouncementData.url}
              placeholder="Enter URL"
              onChange={handelChange}
            />

          </div>


          <div className="flex justify-end w-full rounded"></div>
        </div>
        <div className="w-full form-col md-flex-row">
         <label className="block mb-2 font-semibold text-gray-700">
                       Custom Message
                     </label>
                     <ReactQuill
                       className="w-full mb-6 custom-quill"
                       theme="snow"
            value={createAnouncementData?.message}
                       onChange={handleQuillChange}
                       onFocus={() => setIsQuillFocused(true)}
                       onBlur={() => setIsQuillFocused(false)}
                     />
        </div>

        <div className="form-row">
          <TextField
            size="small"
            variant="outlined"
            label="Image URL"
            placeholder="Enter Image URL"
            name="img_url"
            value={createAnouncementData.img_url}
            onChange={handelChange}
          />
          {createAnouncementData.img_url && (
            <Image
              src={createAnouncementData.img_url}
              preview
              style={{
                height: 156,
                width: 200,
                objectFit: "contain",
              }}
            />
          )}
        </div>
        <div
          className=""
          style={{
            marginTop: "40px",
            marginBottom: "15px",
            gap: "16px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          {rowData?._id ? (
            <div className="flex items-center justify-center gap-4">
            <CustomButton
              value={`Update Announcement`}
              id="dealsApp"
              handleClick={()=>handleUpdateAnnouncement(false)}
              disabled={isQuillFocused}
              className=""
              variant="outlined"
              // href="https://chatgpt.com/"
              // target="_blank"
              icon={UpdateIcon}
            />
            <CustomButton
              value={`Update Announcement & Send Notification`}
              id="dealsApp"
              handleClick={()=>handleUpdateAnnouncement(true)}
              disabled={isQuillFocused}
              className=""
              variant="outlined"
              // href="https://chatgpt.com/"
              // target="_blank"
              icon={UpdateIcon}
            />
            </div>
          ) : (
            <CustomButton
              value={`Create Announcement`}
              id="dealsApp"
              handleClick={handleCreateAnnouncement}
                disabled={isQuillFocused}
              className=""
              variant="outlined"
              // href="https://chatgpt.com/"
              // target="_blank"
              icon={AddCircleOutlineRoundedIcon}
            />
          )}
        </div>
      </Paper>
    </div>
  );
});

export default CreateAnnoucementComponent;
